import { HttpClient } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { IResponse } from 'src/app/@Interfaces';
import { IStatistics } from 'src/app/@Interfaces/statistics.interface';
import { ConfigService } from 'src/app/@Services';
import { DecimalPipe } from '@angular/common';
@Component({
  selector: 'statistics',
  templateUrl: './statistics.component.html',
  styleUrls: ['./statistics.component.scss'],
  imports: [DecimalPipe],
})
export class StatisticsComponent implements OnInit {
  constructor(
    private http: HttpClient,
    private configService: ConfigService,
    private cdr: ChangeDetectorRef,
  ) {}

  protected statistics: IStatistics = {
    premium: 60,
    free: 9,
    monthly: 100000,
    total: 500000,
  };

  ngOnInit(): void {
    this.setStatistics();
  }

  private setStatistics(): void {
    this.http
      .get<IResponse<IStatistics>>(`api/statistics`, { withCredentials: true })
      .subscribe({
        next: (statisticsRes: IResponse<IStatistics>) => {
          this.statistics = statisticsRes.data;
          this.cdr.detectChanges();
        },
        error: () => {
          console.log('error setting statistics');
        },
      });
  }
}
